export const convertSpacesToHTMLFormat = (html: string) => {
  var tempElement = document.createElement('div');
  tempElement.innerHTML = html;

  const traverse = (node: any) => {
    if (node.nodeType === Node.TEXT_NODE) {
      node.nodeValue = node.nodeValue.replaceAll('  ', ' \u00A0');
    } else if (node.nodeType === Node.ELEMENT_NODE) {
      for (var i = 0; i < node.childNodes.length; i++) {
        traverse(node.childNodes[i]);
      }
    }
  };

  traverse(tempElement);

  return tempElement.innerHTML;
};
